import React from "react";

const HomeTestimonials = () => {
  return (
    <section
      className="py-20 xl:py-24 bg-white bg-center"
      style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
    >
      <div className="container">
        <div className="text-center">
          <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 font-medium uppercase rounded-full">
            客户评价
          </span>
          <h2 className="mb-4 text-2xl md:text-3xl !leading-tight text-slate-800 font-bold tracking-tight">
            客户评价
          </h2>
          <p className="mb-20 text-base md:text-lg text-slate-500">
            我们的AI智能软件服务已经帮助众多企业实现了产品智能化升级，以下是部分客户的真实评价。
          </p>
        </div>
        <div className="flex flex-wrap -mx-4 text-slate-800 gap-y-16">
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                集成了AI智能软件服务后，我们的产品智能化水平大幅提升，用户体验得到了显著改善，销售额增长了25%。
              </h3>
              <div className="flex-1"></div>
              <p className="font-bold mb-2">张小明</p>
              <p className="text-slate-500">某智能家电公司产品经理</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                AI智能软件服务的集成非常简单，我们的开发团队只花了一周时间就完成了集成，大大降低了我们的开发成本和时间。
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">李华</p>
              <p className="text-slate-500">某智能穿戴设备公司技术总监</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                AI智能软件服务的数据分析功能非常强大，帮助我们实时监控设备运行状态，及时发现并解决问题，提高了产品的可靠性和稳定性。
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">王芳</p>
              <p className="text-slate-500">某智能家居公司运营总监</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                我们的产品集成了AI智能软件服务后，用户满意度提升了30%，重复购买率也有了显著提高。
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">张伟</p>
              <p className="text-slate-500">某智能玩具公司CEO</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                AI智能软件服务的语音交互功能非常出色，用户可以通过语音轻松控制我们的产品，提供了非常便捷的操作体验。
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">刘洋</p>
              <p className="text-slate-500">某智能音箱公司产品经理</p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full flex flex-col p-8 bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <h3 className="mb-8 text-lg">
                AI智能软件服务的多设备互联互通功能非常强大，实现了我们产品之间的无缝协作，打造了完整的智能生态系统。
              </h3>
              <div className="flex-1"></div>

              <p className="font-bold mb-2">陈静</p>
              <p className="text-slate-500">某智能生态公司技术负责人</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeTestimonials;
